import { ENUM_LCS_NAME, GAME_COUNT } from "../store/enums";

export const sleep = async (ms) => new Promise((rs) => setTimeout(rs, ms));

/**
  @description  получение языка из локалсторадже или куки
  @type () => string<en | ru> 
 */
export const getLang = () => {
  try {
    const urlLang = getParamFromUrl("lang");
    if (urlLang) return urlLang;

    const configLang = getCookie("language");
    const serverLang = configLang?.substring(0, 2)?.toLowerCase?.();
    if (serverLang) return serverLang;

    const lang = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.lang));
    if (!lang) throw new Error("no lang");
    return JSON.parse(localStorage.getItem(ENUM_LCS_NAME.lang));
  } catch {
    const langBrowserFull = navigator.language || navigator?.userLanguage;
    const langMiniBrowser = langBrowserFull.substring(0, 2)?.toLowerCase();
    const langBrowser = langMiniBrowser || "en";
    return langBrowser;
  }
};

/**
  @description вывод строки как денежная сумма
  @type (n:string) => string
 */
export const makeMoney = (n) => {
  return parseFloat(String(n))
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1 ");
};

/**
  @description получение параметров из url
  @type ( name: string ) => string | null
 */
export const getParamFromUrl = (name) => {
  const hashString = window.location.hash.split("?")[1];
  const queryString = window.location.search || hashString;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(name);
};

/**
  @description получение uuid
  @type (  ) => string 
 */
export const getUuid = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );

// setCookie - установка в куки
export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// getCookie - получение куки
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// removeDuplicates - удаление дубликатов из массива объектов по ИД
export const removeDuplicates = (arr, key = "id") =>
  arr.filter((obj, idx, arr) => idx === arr.findIndex((t) => t[key] === obj[key]));

export const checkObject = (x) => typeof x === "object" && !Array.isArray(x) && x !== null;

// messageByCode - получение текста по коду
export const messageByCode = (code) => {
  if (code == 500) return "Currency does not match the user's current currency";
  if (code == 501) return "Invalid top-up amount";
  if (code == 502) return "Amount is less than the minimum allowable";
  if (code == 503) return "The amount exceeds the maximum allowable";
  if (code == 504) return "No suitable crypto address found";
  if (code == 505) return "Invalid withdrawal amount";
  if (code == 506) return "Withdrawal amount is less than the minimum allowable";
  if (code == 507) return "Incorrect bank card number";
  if (code == 508) return "Wrong phone number";
  if (code == 509) return "The amount exceeds the user's balance";
  if (code == 510) return "Invalid crypto address";
  if (code == 511)
    return "The promotional code cannot be used (expired, credited to someone else, etc.)";
  if (code == 513) return "No suitable gateway for replenishment was found";
  if (code == 514) return "Unknown replenishment method";
  if (code == 515) return "User is not registered via email";
  if (code == 516) return "Invalid email value";
  if (code == 517) return "New email already exists";
  if (code == 518)
    return "You have already created a request for withdrawal Wait for it to be processed, and then you can submit your next withdrawal request.";
  if (code == 519) return "Withdrawal amount is greater than the maximum allowable";
  if (code == 520) return "Incorrect output data";
  if (code == 521) return "Invalid verification code (code not found)";
  if (code == 522) return "The verification code does not match the currently authorized user";
  if (code == 523) return "Confirmation code has already been used";
  if (code == 524) return "Email address not confirmed";
  if (code == 525) return "Unsuccessful creation of a replenishment request";
  if (code == 526) return "Email has not changed and is already confirmed";
  if (code == 527) return "The specified email was not found";
  if (code == 528) return "Failed captcha check";
  if (code == 529) return "Replenishment via crypto gateway is not available";
  if (code == 530) return "Crypto gateway wallet not found";
  if (code == 531) return "No available withdrawal methods found";
  if (code == 532) return "Registration and authorization by email is not allowed";
  if (code == 533) return "Registration and authorization by tg is not allowed";
  if (code == 534) return "Invalid email, please contact a manager!"; // 2 одинаковые емаил
  return "An error has occurred";
};

// cancelFs - выход из режима фул скрина
export const cancelFs = async (i = 0) => {
  try {
    if (i == 0) document.exitFullscreen();
    if (i == 1) document.webkitExitFullscreen();
    if (i == 2) document.mozCancelFullScreen();
    if (i == 3) document.msExitFullscreen();
  } catch (e) {
    console.log(e);
    cancelFs(i + 1);
  }
};

// getSliceForCarousel - получение кусочка для карусели
export const getSliceForCarousel = (games, row = 1) => {
  return games?.slice(0, GAME_COUNT * row);

  // for (let i = 0; i < GAME_COUNT / ONE_PORTION; i++) {
  //   const count = GAME_COUNT - ONE_PORTION * i;
  //   if (games.length > count) return games?.slice(0, count);
  //   if (games.length < ONE_PORTION) return games;
  // }
};

//dispatchCusEvent - кинуть пользовательское событие
export const dispatchCusEvent = (eventName, detail = {}, el = window) => {
  el.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
};

export const checkCardNumber = (cardNumber) => {
  const chars = [];
  const len = cardNumber.length;

  // длина номера платежной карты от 13 до 19 символов
  if (len < 13 || len > 19) return false;

  // Проверьте, содержит ли номер карты только цифры
  for (let i = 0; i < len; ++i) {
    const ch = cardNumber.charAt(i);
    if (ch < "0" || ch > "9") return false;
    chars.push(parseInt(ch, 10));
  }

  // Применить алгоритм Луна (удвоить каждую вторую цифру, вычесть 9, если больше 9)
  let start = len % 2 === 0 ? 0 : 1;
  for (let i = start; i < len; i += 2) {
    let x = chars[i] * 2;
    if (x > 9) x -= 9;
    chars[i] = x;
  }

  // Вычислить сумму всех цифр
  let sum = 0;
  for (let i = 0; i < len; ++i) {
    sum += chars[i];
  }

  // проверка делится ли сумма на 10 (проверка Луна)
  return sum % 10 === 0;
};

// toDataURL - возвращает base64
export function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

// sortedByName - сортировка по имени
export const sortedByName = (search, a, b) => {
  const labelA = a.label.toLowerCase();
  const labelB = b.label.toLowerCase();
  const indexA = labelA.indexOf(search.toLowerCase());
  const indexB = labelB.indexOf(search.toLowerCase());

  if (indexA !== -1 && indexB !== -1) return indexA - indexB;
  if (indexA !== -1) return -1;
  if (indexB !== -1) return 1;

  return a.originalIndex - b.originalIndex;
};

export function updateImageUrl(imageUrl) {
  try {
    // FIXME временное решение
    // return imageUrl;

    // Разбираем URL
    const url = new URL(imageUrl);
    const currentDomain = window.location.hostname;
    // const mainDomain = currentDomain
    //   .replace("www", "")
    //   .replace("crypto.", "")
    //   .replace("dev.", "")
    //   .replace("demo.", "");
    const externalDomain = url.hostname?.replace("r.gamesstatic.com", "gamesstatic.com");
    // const newUrl = `https://static.${mainDomain}${url.pathname}?domain=${externalDomain}`;
    const newUrl = `https://${currentDomain}${url.pathname}?domain=${externalDomain}`;

    // if (TEST_MODE) return `https://static.${mainDomain}${url.pathname}?domain=${externalDomain}`;
    return newUrl;
  } catch (e) {
    if (e instanceof TypeError) {
      if (e.message.includes("Invalid URL")) return imageUrl;
    }

    console.error("error for: " + imageUrl, e);
    return imageUrl;
  }
}

export function validateEmail(address) {
  let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; // eslint-disable-line

  return reg.test(address);
}

export function formatToDDMMYYYY(dateStr) {
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat("ru-RU").format(date);
}

export function getNextWeekdayDate(serverDateStr, targetWeekDay) {
  const date = new Date(serverDateStr);

  let jsDay = date.getDay(); // JS: 0 (Sunday) → 6 (Saturday)
  const myDayIndex = (jsDay + 6) % 7; // теперь 0 — Monday, 1 — Tuesday, ..., 6 — Sunday

  if (myDayIndex === targetWeekDay) {
    return { date: formatToDDMMYYYY(date.toISOString()), weekDay: myDayIndex };
  }

  // Сколько дней нужно прибавить до следующего нужного дня
  const daysToAdd = (targetWeekDay + 7 - myDayIndex) % 7 || 7;
  date.setDate(date.getDate() + daysToAdd);

  return {
    date: formatToDDMMYYYY(date.toISOString()),
    weekDay: targetWeekDay
  };
}

export function getDayOfWeekByOffset(offsetMinutes = 0) {
  const now = new Date();
  const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
  const localTime = new Date(utcTime + offsetMinutes * 60000);
  return localTime.getDay();
}

export const formatDateTime = (dateTime) => {
  const [date, tempTime] = dateTime.split(" ");
  const time = tempTime?.slice(0, 5) || "";
  return `${formatToDDMMYYYY(date)} ${time}`;
};

export const ENUM_DEPOSIT_STATUS = {
  any: "any",
  created: "created",
  paid: "paid",
  canceled: "canceled",
  expired: "expired",
  moderation: "moderation",
  paidout: "success",
  inprocess: "in process",
  refunded: "refunded",
  failed: "failed",
  unknown: "unknown"
};

export const getUrlProviders = (name) => {
  const id = name.toLowerCase().replaceAll(" ", "_");
  return `/images/providers/${id}.png`;
};

export const getUrlProviderHover = (name) => {
  const id = name.toLowerCase().replaceAll(" ", "_");
  return `/images/providers/hover/${id}.png`;
};

export const getUrlProviderLogo = (name) => {
  const id = name.toLowerCase().replaceAll(" ", "_");
  return `/images/providers/logo/${id}.svg`;
};

export const LIVE_TYPE_GAME = [
  "live dealer",
  "roulette",
  "baccarat",
  "poker",
  "andar bahar",
  "dragon tiger",
  "sic bo",
  "teen patti",
  "card"
];

export const LIVE_PROVIDER_NAME = ["Ezugi", "Vivo"];

export const checkGameIsLive = (game) => {
  const providerName = game.providerName || game.provider;
  return LIVE_TYPE_GAME.includes(game.type) && LIVE_PROVIDER_NAME.includes(providerName);
};

export const parseHashString = (hashString) => {
  const parts = hashString.split("#").filter(Boolean);
  const result = {};

  parts.forEach((part) => {
    if (part.includes("?")) {
      const [key, query] = part.split("?");
      const params = new URLSearchParams(query);
      const paramObj = {};
      params.forEach((value, name) => {
        paramObj[name] = value;
      });
      result[key] = paramObj;
    } else {
      result[part] = true;
    }
  });

  return result;
};

export const checkBonusGame = (game) => game.source?.search("bonus") === 0;
